<template>
  <v-app class="grey lighten-5">
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12 col-xl-10">
          <v-row class="justify-start">
            <v-col class="col-12 col-md-8 col-lg-6 col-xl-5">
              <div class="d-inline-flex primary--text">
                <v-icon class="mr-2" color="primary" size="35">payment</v-icon>
                <h1 class="text-md-left font-weight-bold primary--text">{{$t('patientSearchPsi.title')}}</h1>
              </div>
            </v-col>
          </v-row>
          <hr class="primary--lightGray mt-3" />
          <v-col class="col-12">
            <v-row>
              <p class="primary--lightGray schedule-text mt-3">
                {{$t('patientSearchPsi.subtitle')}}
              </p>
            </v-row>
          </v-col>
          <v-row>
            <v-col class="col-12 col-md-6">
              <v-text-field
                solo
                prepend-inner-icon="people"
                label="Pesquise pelo nome do Psicólogo"
                v-model="list_search.name"
                required
                background-color="#f7f1e4"
              ></v-text-field>
            </v-col>
            <v-col class="col-12 col-md-6">
              <v-autocomplete
                solo
                label="Pesquise por especialidade"
                :items="specialities"
                item-text="description"
                item-value="description"
                v-model="list_search.speciality"
                prepend-inner-icon="record_voice_over"
                hide-no-data
                clearable
                background-color="#f7f1e4"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="col-12 col-md-2">
              <span class="text-center text-md-left primary--text ml-md-4">Sexo:</span>
              <v-select
                prepend-inner-icon="person"
                hide-details
                solo
                flat
                label="Feminino, Masculino ou Outros"
                :items="list_gender"
                v-model="list_search.gender"
                background-color="#F7F7F7"
                color="primary"
              ></v-select>
            </v-col>
            <v-col class="col-12 col-md-2">
              <span class="text-center text-md-left primary--text ml-md-4">Moeda:</span>
              <v-select
                prepend-inner-icon="attach_money"
                hide-details
                solo
                flat
                :label="list_currency[0]"
                :items="list_currency"
                v-model="list_search.currency"
                @change="getCurrency"
                background-color="#F7F7F7"
                color="primary"
              ></v-select>
            </v-col>
            <v-col class="col-12 col-md-2">
              <span class="text-center text-md-left primary--text ml-md-4">
                Valor máximo:
              </span>
              <v-text-field
                solo
                flat
                prepend-inner-icon="eject"
                :label="labelMoney"
                v-model="list_search.money"
                background-color="#F7F7F7"
              ></v-text-field>
            </v-col>
            <v-col class="col-12 col-md-3">
              <span class="text-center text-md-left primary--text ml-md-4">Agenda:</span>
              <div class="d-flex align-center filter-switch" style="background-color: #F7F7F7;">
                <v-icon color="primary" class="ml-3 mr-3">event_available</v-icon>
                <v-switch
                  v-model="list_search.has_vacancies"
                  label="Horário disponível"
                  color="secondary"
                  hide-details
                  dense
                  inset
                  @change="searchPsychologists"
                  class="ma-0 pa-0"
                ></v-switch>
              </div>
            </v-col>
            <v-col class="col-12 col-md-3">
              <v-btn
                color="secondary"
                height="48"
                width="100%"
                class="navbar-buttons white--text mt-md-6"
                @click="searchPsychologists"
                :loading="isLoading"
                :disabled="isLoading"
              >
                <v-icon color="primary" size="32" class="mr-2 white--text">search</v-icon>PESQUISAR
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="col-12">
              <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
                <p>Carregando...</p>
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="mb-0"
                ></v-progress-circular>
              </div>

              <v-row v-if="isPsy && !isLoading">
                <v-col class="col-12 col-md-6 col-xl-4" v-for="user in psy" :key="user.id">
                  <CardPsyPublico :psy="user" />
                </v-col>
              </v-row>
              <div class="text-center">
                <v-pagination v-model="pageSearch" :length="lengthPage"></v-pagination>
              </div>

              <div v-if="notPsy && !isLoading" class="text-center">
                <p>
                  <v-icon x-large color="gray">sentiment_very_dissatisfied</v-icon>
                  Ops! Nenhum psicologo encontrado.
                </p>
                <p>
                  Entre em contato com a nossa
                  <router-link to="help">equipe de suporte</router-link>para auxiliá-lo.
                </p>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <ModalWelcome
      :is-dialog-open="openModalInfo"
      @close="openModalInfo = false"
    />
  </v-app>
</template>

<script>
import Api from '../../services/httpClient';
import getLanguage from '../../utils/getLanguage';
import ModalWelcome from '../../components/ModalWelcome';
import CardPsyPublico from '@/components/CardPsyPublico';

export default {
  name: 'BuscaPaciente',

  components: {
    CardPsyPublico,
    ModalWelcome,
  },

  data: () => ({
    cod: '',
    labelMoney: 'Até €90',
    list_gender: ['Masculino', 'Feminino', 'Outros'],
    list_currency: ['Euro', 'Real'],
    list_search: {
      name: '',
      gender: '',
      currency: '',
      money: '',
      speciality: '',
      has_vacancies: false,
    },
    psy: [],
    isPsy: false,
    notPsy: false,
    specialities: [],
    page: 1,
    isLoading: false,
    openModalInfo: false,
    pageSearch: 1,
    lengthPage: 1,
    lang: '',
  }),
  
  created() {
    this.getSpecialities();
    if (this.$route.params.name) {
      this.list_search.name = this.$route.params.name;
    }
    this.searchPsychologists();
    this.lang = getLanguage(window.location.href);
    this.lang === 'pt-BR' ? (this.list_currency = ['Real']) : (this.list_currency = ['Euro']);
    this.list_search.currency = this.list_currency[0]
    this.getCurrency(this.list_currency[0]);
  },
  watch: {
    pageSearch() {
      this.searchPsychologists();
    },
  },

  async mounted() {
    this.openModalInfo = true;
  },
  methods: {
    getCurrency(val) {
      if (val === 'Euro') {
        this.labelMoney = 'Até €90';
      } else {
        this.labelMoney = 'Até R$90';
      }
    },
    async searchPsychologists() {
      try {
        this.isLoading = true;
        this.psy = [];
        const {
          name, gender, currency, money, speciality, has_vacancies,
        } = this.list_search;

        /**
         * Cria duas variaves para receber o valor,
         * e adepender do tipo moeda coloca o valor em uma das duas.
         */
        // eslint-disable-next-line camelcase
        let br_value = '';
        // eslint-disable-next-line camelcase
        let pt_value = '';
        if (currency === 'Real') {
          // eslint-disable-next-line camelcase
          br_value = money;
        } else {
          // eslint-disable-next-line camelcase
          pt_value = money;
        }

        const { data } = await Api.get('/psychologists/', {
          params: {
            name,
            gender,
            currency: currency.toLowerCase(),
            br_value,
            pt_value,
            speciality,
            has_vacancies: has_vacancies ? 1 : '',
            page: this.pageSearch,
          },
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        });

        if (data.results.length > 0) {
          this.lengthPage = Math.ceil(data.count / 12);
          this.psy = data.results;
          this.isPsy = true;
          this.notPsy = false;
        } else {
          this.isPsy = false;
          this.notPsy = true;
        }
        // console.log(this.psy);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    getSpecialities() {
      Api.get('/specialities/', {
        params: {
          page: this.page,
        },
      }).then((res) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const item of res.data.results) {
          this.specialities.push(item);
        }
        if (res.data.next != null) {
          this.page += 1;
          this.getSpecialities();
        }
      });
    },
  },
};
</script>

<style lang="css" scoped>
.toolbar {
  height: auto;
  color: #f7f1e4;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

* >>> .v-text-field__slot .v-label,
* >>> .v-select__slot .v-label {
  color: #02a554;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.filter-switch {
  height: 48px;
  border-radius: 4px;
}

.filter-switch >>> .v-input--switch {
  margin: 0;
}

.filter-switch >>> .v-messages {
  display: none;
}

.filter-switch >>> .v-label {
  color: var(--v-secondary-base);
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
